import UpdateSiteModal from './devices-out-of-range-modal.connect'

export default UpdateSiteModal
